var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content",class:_vm.cur==_vm.index?'active':'',style:({width:_vm.width}),on:{"click":_vm.cilckMethod}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }